import React from 'react';
import DiscountBadgeOrange from "../../../../icons/discount-badge-orange.svg";

type ProductCardProduct = {
  id: string;
  name: string;
  price: string;
  originalPrice?: string | null;
  discount?: number | null;
  image: string;
  url?: string;
};

interface ProductCardProps {
  product: ProductCardProduct;
  onProductClick?: (product: ProductCardProduct) => void;
}

export const ProductCard: React.FC<ProductCardProps> = ({
  product,
  onProductClick
}) => {
  const handleClick = () => {
    if (product.url) {
      if (onProductClick) {
        onProductClick(product);
      }
      window.location.href = product.url;
    }
  };

  // Check if there's an actual discount
  const hasDiscount = product.discount && 
    product.discount > 0 && 
    product.originalPrice && 
    product.originalPrice !== product.price;

  return (
    <div 
      className="keen-slider__slide side-menu-product-card"
      onClick={handleClick}
      style={{ cursor: 'pointer' }}
    >
      <div className="side-menu-product-image-container">
        <div className="side-menu-product-image-wrapper">
          <img 
            src={product.image} 
            alt={product.name}
            className="side-menu-product-image"
            onError={(e) => {
              e.currentTarget.style.display = 'none'
              e.currentTarget.nextElementSibling?.classList.remove('side-menu-product-placeholder-hidden')
            }}
          />
          <div className="side-menu-product-placeholder side-menu-product-placeholder-hidden"></div>
        </div>
        {hasDiscount && (
          <div className="side-menu-product-discount-badge">
            <img src={DiscountBadgeOrange} alt="discount badge" className="side-menu-product-discount-bg" />
            <span className="side-menu-product-discount-text">-{product.discount}%</span>
          </div>
        )}
      </div>
      <h4 className="side-menu-product-title">{product.name}</h4>
      <div className="side-menu-product-price-container">
        <span className="side-menu-product-price">{product.originalPrice}</span>
        {hasDiscount && (
          <span className="side-menu-product-original-price">{product.price}</span>
        )}
      </div>
      <button className="side-menu-product-arrow-btn">
        <img src="/img_v4/icons/chevron-right-icon.svg" alt="" aria-hidden="true" className="side-menu-product-arrow" />
      </button>
    </div>
  );
};
